import { API_BASE_URL } from "../../config/apiConfig";

// Silently exchanges the stored refresh token for a fresh access token
// (+ rotated refresh token), so a user doesn't get stranded mid-session
// just because their 2h access token expired while the tab was open.
// Returns true on success (localStorage already updated), false if the
// refresh token itself is missing/invalid/expired — callers should treat
// false as "the user needs to log in again."
export const refreshAccessToken = async () => {
    const storedRefreshToken = localStorage.getItem("refreshToken");
    if (!storedRefreshToken) return false;

    try {
        const res = await fetch(`${API_BASE_URL}/api/users/refresh-token`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken: storedRefreshToken }),
        });

        if (!res.ok) return false;

        const data = await res.json();
        if (!data.token) return false;

        localStorage.setItem("token", data.token);
        if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
        return true;
    } catch (error) {
        console.error("Silent token refresh failed:", error);
        return false;
    }
};
